var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:[_vm.pushClass, 'ad-instrument-data-value', _vm.isWordWrap ? '' : 'text-nowrap'],attrs:{"title":_vm.formatedValue}},[_vm._v(_vm._s(_vm.formatedValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }